//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
class _utils {
  constructor() {
    this.USER_ID_KEY = "USER_ID";
    this.CAMPAIGN_ID_KEY = "CAMPAIGN_ID";
    this.REPEATED_SCAN_KEY = "REPEATED_SCAN_KEY";

    this.isCacheSupported = this.isLocalStorageAvailable();
  }

  isMobileSafari() {
    return !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
  }

  isIosDevice() {
    const deviceType = this.getDeviceDetails().osName;
    return (
      deviceType.toLowerCase() === "iphone" ||
      deviceType.toLowerCase() === "ipad"
    );
  }

  isMobile(ignoreTablets = false) {
    const deviceDetails = this.getDeviceDetails();

    if (ignoreTablets) {
      return (
        deviceDetails.osName == "iPhone" || deviceDetails.osName === "Android"
      );
    }

    return (
      (typeof DeviceOrientationEvent !== "undefined" &&
        typeof DeviceOrientationEvent.requestPermission === "function" &&
        deviceDetails.osName.toLowerCase() == "macintosh") ||
      deviceDetails.osName == "iPhone" ||
      deviceDetails.osName == "iPad" ||
      deviceDetails.osName === "Android"
    );
  }

  getDeviceDetails() {
    var module = {
      options: [],
      header: [
        navigator.platform,
        navigator.userAgent,
        navigator.appVersion,
        navigator.vendor,
        window.opera,
      ],
      dataos: [
        { name: "Windows Phone", value: "Windows Phone", version: "OS" },
        { name: "Windows", value: "Win", version: "NT" },
        { name: "iPhone", value: "iPhone", version: "OS" },
        { name: "iPad", value: "iPad", version: "OS" },
        { name: "Kindle", value: "Silk", version: "Silk" },
        { name: "Android", value: "Android", version: "Android" },
        { name: "PlayBook", value: "PlayBook", version: "OS" },
        { name: "BlackBerry", value: "BlackBerry", version: "/" },
        { name: "Macintosh", value: "Mac", version: "OS X" },
        { name: "Linux", value: "Linux", version: "rv" },
        { name: "Palm", value: "Palm", version: "PalmOS" },
      ],
      databrowser: [
        { name: "Chrome", value: "Chrome", version: "Chrome" },
        { name: "Firefox", value: "Firefox", version: "Firefox" },
        { name: "Safari", value: "Safari", version: "Version" },
        { name: "Internet Explorer", value: "MSIE", version: "MSIE" },
        { name: "Opera", value: "Opera", version: "Opera" },
        { name: "BlackBerry", value: "CLDC", version: "CLDC" },
        { name: "Mozilla", value: "Mozilla", version: "Mozilla" },
      ],
      init: function () {
        var agent = this.header.join(" "),
          os = this.matchItem(agent, this.dataos),
          browser = this.matchItem(agent, this.databrowser);

        return { os: os, browser: browser };
      },
      matchItem: function (string, data) {
        var i = 0,
          j = 0,
          regex,
          regexv,
          match,
          matches,
          version;

        for (i = 0; i < data.length; i += 1) {
          regex = new RegExp(data[i].value, "i");
          match = regex.test(string);
          if (match) {
            regexv = new RegExp(data[i].version + "[- /:;]([\\d._]+)", "i");
            matches = string.match(regexv);
            version = "";
            if (matches) {
              if (matches[1]) {
                matches = matches[1];
              }
            }
            if (matches) {
              matches = matches.split(/[._]+/);
              for (j = 0; j < matches.length; j += 1) {
                if (j === 0) {
                  version += matches[j] + ".";
                } else {
                  version += matches[j];
                }
              }
            } else {
              version = "0";
            }
            return {
              name: data[i].name,
              version: parseFloat(version),
            };
          }
        }
        return { name: "unknown", version: 0 };
      },
    };
    var e = module.init();
    return {
      osName: e.os.name,
      osVersion: e.os.version,
      browserName: e.browser.name,
      browserVersion: e.browser.version,
    };
  }

  generateUuidV4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  }

  getIdFromLocalStorage(key) {
    let id = this.isCacheSupported ? localStorage.getItem(key) : null;
    if (id == null) {
      id = this.generateUuidV4();
      if (this.isCacheSupported) {
        localStorage.setItem(key, id);
      }
    }
    return id;
  }

  setValueInLocalStorage(key, value) {
    if (this.isCacheSupported) {
      localStorage.setItem(key, value);
    }
  }

  isLocalStorageAvailable() {
    try {
      let storage = window["localStorage"],
        x = "__storage_test__";
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      console.log("localStorage unavailable");
      return false;
    }
  }

  getHash(message) {
    let hash = 0;
    if (message.length == 0) return "";
    for (var i = 0; i < message.length; i++) {
      const char = message.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    return hash.toString();
  }
}

const Utils = new _utils();
export default Utils;
